import React, { Component } from 'react';

import SimoDeviceActionButton from './SimoDeviceActionButton';
import ExpireSimoDeviceModal from 'components/modals/ExpireSimoDeviceModal';
import RestoreSimoDeviceModal from 'components/modals/RestoreSimoDeviceModal';
import SuspendSimoDeviceModal from 'components/modals/SuspendSimoDeviceModal';
import UpdateSimoDeviceModal from 'components/modals/UpdateSimoDeviceModal';
import ChangeSimoDeviceAccountModal from 'components/modals/ChangeSimoDeviceAccountModal';
import { can, permActions } from 'permissions';

import styles from './styles.module.scss';

const {
  EXPIRE_SIMO_DEVICE,
  SUSPEND_SIMO_DEVICE,
  RESTORE_SIMO_DEVICE,
  UPDATE_SIMO_DEVICE,
  CHANGE_SIMO_ACCOUNT,
} = permActions;

class SimoDeviceActions extends Component {
  state = {
    opennedModal: '',
  };

  setOpennedModal = (modal) => this.setState({ opennedModal: modal });
  closeModal = () => this.setState({ opennedModal: '' });

  render() {
    const { simoDevice, loggedInUser, loadDeviceSubs } = this.props;
    const { opennedModal } = this.state;

    const isExpired = simoDevice?.simo_status === 'expired';
    const isSuspended = simoDevice?.simo_status === 'suspended';
    const isActive = simoDevice?.simo_status === 'active';

    const showUpdateDevice =
      !isExpired && can(loggedInUser, UPDATE_SIMO_DEVICE);
    const showChangeAccount =
      !isExpired && can(loggedInUser, CHANGE_SIMO_ACCOUNT);
    const showExpire = !isExpired && can(loggedInUser, EXPIRE_SIMO_DEVICE);
    const showSuspend = isActive && can(loggedInUser, SUSPEND_SIMO_DEVICE);
    const showRestore = isSuspended && can(loggedInUser, RESTORE_SIMO_DEVICE);

    const buttons = [
      {
        id: UPDATE_SIMO_DEVICE,
        iconPath: '/images/icons/subActions/device-icon.svg',
        text: 'Update Device',
        onClick: this.setOpennedModal,
        isShown: showUpdateDevice,
      },
      {
        id: CHANGE_SIMO_ACCOUNT,
        iconPath: '/images/icons/subActions/settings-icon.svg',
        text: 'Change Account',
        onClick: this.setOpennedModal,
        isShown: showChangeAccount,
      },
      {
        id: SUSPEND_SIMO_DEVICE,
        iconPath: '/images/icons/subActions/pause-icon.svg',
        text: 'Suspend Device',
        onClick: this.setOpennedModal,
        isShown: showSuspend,
      },
      {
        id: RESTORE_SIMO_DEVICE,
        iconPath: '/images/icons/subActions/play-icon.svg',
        text: 'Restore Device',
        onClick: this.setOpennedModal,
        isShown: showRestore,
      },
      {
        id: EXPIRE_SIMO_DEVICE,
        iconPath: '/images/icons/subActions/cross-icon.svg',
        text: 'Expire Device',
        onClick: this.setOpennedModal,
        isShown: showExpire,
      },
    ];

    return (
      <div className={styles.section}>
        <div className={styles.items}>
          {buttons.map((button) => (
            <SimoDeviceActionButton key={button.id} {...button} />
          ))}
          <ExpireSimoDeviceModal
            simoDevice={simoDevice}
            isOpen={opennedModal === EXPIRE_SIMO_DEVICE}
            closeModal={this.closeModal}
            loadDeviceSubs={loadDeviceSubs}
          />
          <SuspendSimoDeviceModal
            simoDevice={simoDevice}
            isOpen={opennedModal === SUSPEND_SIMO_DEVICE}
            closeModal={this.closeModal}
            loadDeviceSubs={loadDeviceSubs}
          />
          <RestoreSimoDeviceModal
            simoDevice={simoDevice}
            isOpen={opennedModal === RESTORE_SIMO_DEVICE}
            closeModal={this.closeModal}
            loadDeviceSubs={loadDeviceSubs}
          />
          <UpdateSimoDeviceModal
            simoDevice={simoDevice}
            isOpen={opennedModal === UPDATE_SIMO_DEVICE}
            closeModal={this.closeModal}
            loadDeviceSubs={loadDeviceSubs}
          />
          <ChangeSimoDeviceAccountModal
            simoDevice={simoDevice}
            isOpen={opennedModal === CHANGE_SIMO_ACCOUNT}
            closeModal={this.closeModal}
          />
        </div>
      </div>
    );
  }
}

export default SimoDeviceActions;
